import * as React from "react";
import { Button } from "@progress/kendo-react-buttons";
import Currencylist from "./currencylist";
import styles from "../Settings.module.scss";
import { addCurrency } from "services/currencyService";
import { toast } from "react-toastify";
import EditCurrency from "./Editcurrency";

const Currency = (props) => {
  const [addnewform, setaddnewform] = React.useState(false);
  const closeform = () => {
    setaddnewform(false);
  };
  React.useEffect(() => {
    if (props.onClose === false) {
      closeform();
    }
  }, [props.onClose]);

  const handleSubmit = async (e) => {
    setaddnewform(false);
    try {
      const result = await addCurrency(e);
      if (result.success) {
        toast.success("Currency Added");
      } else {
        toast.error("Error Occurred");
      }
    } catch (error) {
      toast.error("Error Occurred");
    }
  };

  return (
    <div className="d-flex flex-column h-100 w-100">
      <div className="d-flex justify-content-end mb-3 flex-shrink-0">
        <Button
          className={`common-btn p-2`}
          onClick={() => {
            setaddnewform(true);
            props.open();
          }}
        >
          Add <br />
          Currency
        </Button>
      </div>

      <div className="flex-grow-1 settings-grid-wrapper overflow-auto" style={{ minHeight: 0 }}>
        <Currencylist />
      </div>

      {addnewform && (
        <EditCurrency
          cancelEdit={closeform}
          onSubmit={handleSubmit}
          type="addNew"
        />
      )}
    </div>
  );
};

export default Currency;
